import { render, staticRenderFns } from "./BandejaLinkPacientePresentacionPTIComponente.vue?vue&type=template&id=484c9a6e"
import script from "./BandejaLinkPacientePresentacionPTIComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPacientePresentacionPTIComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports